export default class ProduitConfigNiveauxController {
    static $inject = ['ProduitNiveauxTrameService', 'ProduitNiveauxElementsService', 'TypesNiveauxHierarchique'];

    constructor(ProduitNiveauxTrameService, ProduitNiveauxElementsService, TypesNiveauxHierarchique) {
        this.ProduitNiveauxTrameService = ProduitNiveauxTrameService;
        this.ProduitNiveauxElementsService = ProduitNiveauxElementsService;
        this.TypesNiveauxHierarchique = TypesNiveauxHierarchique;
    }

    $onInit() {
        this.name = 'ProduitNiveaux';

        this.treeviewTrameConfig = { orderByFunction: 'position' };

        this.treeviewTrameService = this.ProduitNiveauxTrameService;

        this.treeviewElementsConfig = {
            dropDisabled: false,
            //les elements de types pays sont les feuilles, pas d'action possible pour l'instant
            leafTypes: [this.TypesNiveauxHierarchique.Pays.value, this.TypesNiveauxHierarchique.Libre.value],
            leafTypesIcons: {}
        };
        //on set la valeur de "leafTypesIcons" en deux etape,
        //car on a besoin d'utiliser la valeur d'une variable (constant this.TypesNiveauxHierarchique.Pays.value)
        //en tant que cle d'objet
        this.treeviewElementsConfig.leafTypesIcons[this.TypesNiveauxHierarchique.Pays.value] = 'globe';
        this.treeviewElementsConfig.leafTypesIcons[this.TypesNiveauxHierarchique.Libre.value] = 'play';

        this.treeviewElementsService = this.ProduitNiveauxElementsService;
    }
}
